/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type WrapperCardPatientQueryVariables = {
    id: string;
};
export type WrapperCardPatientQueryResponse = {
    readonly patientById: {
        readonly " $fragmentRefs": FragmentRefs<"CardPatient_Patient">;
    } | null;
};
export type WrapperCardPatientQuery = {
    readonly response: WrapperCardPatientQueryResponse;
    readonly variables: WrapperCardPatientQueryVariables;
};



/*
query WrapperCardPatientQuery(
  $id: MongoID!
) {
  patientById(_id: $id) {
    ...CardPatient_Patient
    id
  }
}

fragment AvatarNode_Node on Node {
  __isNode: __typename
  __typename
  ... on Group {
    groupName: name
  }
  ... on Patient {
    name
    oid_avatar
    isOnline
  }
  ... on Provider {
    name
    oid_avatar
    isOnline
  }
  ... on User {
    name
    oid_avatar
    isOnline
  }
  ... on ChatActivity {
    patient {
      name
      oid_avatar
      isOnline
      id
    }
  }
}

fragment CardPatient_Patient on Patient {
  ...AvatarNode_Node
  _id
  name
  firstname
  lastname
  medicalRecordNumber
  createdAt
  lastLogin
  dateOfBirth {
    day
    month
    year
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "_id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oid_avatar",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isOnline",
  "storageKey": null
},
v6 = [
  (v4/*: any*/),
  (v5/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WrapperCardPatientQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Patient",
        "kind": "LinkedField",
        "name": "patientById",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CardPatient_Patient"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WrapperCardPatientQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Patient",
        "kind": "LinkedField",
        "name": "patientById",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "_id",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstname",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastname",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "medicalRecordNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastLogin",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PatientDateOfBirth",
            "kind": "LinkedField",
            "name": "dateOfBirth",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "day",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "month",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "year",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": "groupName",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  }
                ],
                "type": "Group",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v6/*: any*/),
                "type": "Patient",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v6/*: any*/),
                "type": "Provider",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v6/*: any*/),
                "type": "User",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Patient",
                    "kind": "LinkedField",
                    "name": "patient",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "ChatActivity",
                "abstractKey": null
              }
            ],
            "type": "Node",
            "abstractKey": "__isNode"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "205f05f5e3363066e04ea7bfc801a911",
    "id": null,
    "metadata": {},
    "name": "WrapperCardPatientQuery",
    "operationKind": "query",
    "text": "query WrapperCardPatientQuery(\n  $id: MongoID!\n) {\n  patientById(_id: $id) {\n    ...CardPatient_Patient\n    id\n  }\n}\n\nfragment AvatarNode_Node on Node {\n  __isNode: __typename\n  __typename\n  ... on Group {\n    groupName: name\n  }\n  ... on Patient {\n    name\n    oid_avatar\n    isOnline\n  }\n  ... on Provider {\n    name\n    oid_avatar\n    isOnline\n  }\n  ... on User {\n    name\n    oid_avatar\n    isOnline\n  }\n  ... on ChatActivity {\n    patient {\n      name\n      oid_avatar\n      isOnline\n      id\n    }\n  }\n}\n\nfragment CardPatient_Patient on Patient {\n  ...AvatarNode_Node\n  _id\n  name\n  firstname\n  lastname\n  medicalRecordNumber\n  createdAt\n  lastLogin\n  dateOfBirth {\n    day\n    month\n    year\n  }\n}\n"
  }
};
})();
(node as any).hash = 'e044e20937e6a414b94485ba2b61f6cc';
export default node;
